import React, { useContext, useState, useEffect, useRef } from "react";
import { CartContext } from "../../context/CartContext";
import { FaShoppingCart, FaTimes, FaRegClock, FaPlus } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { buildOrderPayload } from "../../utils/buildOrderPayload";
import { getMyAccountId } from "../../utils/config";
import { useLanguage } from "../../context/LanguageContext";
export default function CartDrawer() {
    const { cartItems, cartCount, isOpen, closeCart, clearCart, removeFromCart } =
        useContext(CartContext);

    const user = JSON.parse(localStorage.getItem("user"));

    const itemSubtotalCents = (item) => {
        const price = item.price ?? item.unitPrice;
        return Math.round(Math.round(price * 10000) * item.qty / 100);
    };

    const subtotalCents = cartItems.reduce((t, item) => t + itemSubtotalCents(item), 0);
    const subtotal = subtotalCents / 100;

    const gravadoCents = cartItems
        .filter((item) => item.payTax)
        .reduce((t, item) => t + itemSubtotalCents(item), 0);

    const porcentaje = Number(user?.porcentaje || 0) / 100;
    const ivaTotal = Math.round(gravadoCents * porcentaje) / 100;
    const totalFinal = subtotal + ivaTotal;

    const [isProformaMode, setIsProformaMode] = useState(
        () => localStorage.getItem("order_mode") === "proforma"
    );

    useEffect(() => {
        const sync = () => setIsProformaMode(localStorage.getItem("order_mode") === "proforma");
        window.addEventListener("orderModeChange", sync);
        return () => window.removeEventListener("orderModeChange", sync);
    }, []);

    const history = useHistory();
    const MYACCOUNT_ID = getMyAccountId();
    const { t, switchLanguage, language } = useLanguage();

    // Cada item nuevo se agrega al final del arreglo (CartContext.addToCart), asi
    // que cuando la cantidad de items sube (no cuando solo cambia qty de uno ya
    // existente), el ultimo elemento es el recien agregado — hacemos scroll hasta
    // ahi para que se vea de una vez sin que el usuario tenga que buscarlo.
    const listRef = useRef(null);
    const prevCountRef = useRef(cartItems.length);

    useEffect(() => {
        if (cartItems.length > prevCountRef.current && listRef.current) {
            listRef.current.scrollTo({ top: listRef.current.scrollHeight, behavior: "smooth" });
        }
        prevCountRef.current = cartItems.length;
    }, [cartItems.length]);
    return (
        <>
            {/* BACKDROP */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/40 z-[998]"
                    onClick={closeCart}
                ></div>
            )}

            {/* DRAWER */}
            <div
                className={`
                    fixed top-0 right-0 h-screen w-[100%] max-w-[475px]
                    bg-white shadow-2xl z-[999]
                    transform transition-transform duration-300
                    ${isOpen ? "translate-x-0" : "translate-x-full"}
                `}
            >
                {/* WRAPPER PARA RESPONSIVE */}
                <div className="flex flex-col h-full">

                    {/* HEADER */}
                    <div className="flex items-center justify-between p-4 border-b bg-white">

                        {/* TÍTULO + BADGE */}
                        <div className="flex items-center gap-3">
                            <h2 className="text-xl font-extrabold text-gray-900">{t.cartTitle}</h2>

                            {cartItems.length > 0 && (
                                <span className="bg-brand-primary text-white text-xs font-bold px-2 py-1 rounded-full">
                                    {cartCount}
                                </span>
                            )}
                        </div>

                        {/* QUICK ORDER + TOOLTIP */}
                        <div className="relative group">
                            <button
                                onClick={() => {
                                    closeCart();        // cerrar drawer
                                    history.push("/order-express");  // navegar a OrderExpress
                                }}
                                className="
                                    flex items-center justify-center w-8 h-8 
                                    text-black border border-gray-300 
                                    rounded-md hover:bg-gray-100 transition
                                "
                            >
                                <FaRegClock className="text-lg" />
                            </button>


                            {/* TOOLTIP ESTILO ETIQUETA NEGRA */}
                            <div
                                className="
                                    absolute left-[-115px] top-1/2 -translate-y-1/2
                                    bg-black text-white text-xs font-medium
                                    px-3 py-1 rounded
                                    opacity-0 group-hover:opacity-100
                                    translate-x-2 group-hover:translate-x-0
                                    transition-all duration-200
                                    whitespace-nowrap
                                    pointer-events-none
                                    shadow-lg
                                "
                            >
                                {t.menuQuickOrder}

                                {/* TRIANGULITO */}
                                <div
                                    className="
                                        absolute top-1/2 right-[-6px] -translate-y-1/2 
                                        w-0 h-0 
                                        border-t-[6px] border-t-transparent
                                        border-b-[6px] border-b-transparent
                                        border-l-[6px] border-l-black
                                    "
                                ></div>
                            </div>
                        </div>

                        {/* CLOSE DRAWER */}
                        <button onClick={closeCart}>
                            <FaTimes className="text-gray-600 text-xl hover:text-black transition" />
                        </button>
                    </div>

                    {/* LISTA DE ITEMS */}
                    <div ref={listRef} className="p-4 overflow-y-auto flex-1 bg-gray-50">

                        {cartItems.length === 0 ? (
                            <p className="text-gray-500 text-center mt-10">
                                Your cart is empty.
                            </p>
                        ) : (
                            cartItems.map((item, idx) => (
                                <div
                                    key={idx}
                                    className="
                                        relative flex gap-5 p-5 
                                        border-b last:border-none 
                                        bg-white rounded-xl 
                                        shadow-md hover:shadow-lg 
                                        transition mb-4
                                    "
                                >
                                    {/* BOTÓN ELIMINAR ITEM */}
                                    <button
                                        onClick={() => removeFromCart(item.idProduct)}
                                        className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition"
                                        title="Remove item"
                                    >
                                        <FaTimes className="text-base" />
                                    </button>

                                    {/* IMG */}
                                    <img
                                        src={`https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${item.code || item.productId}.jpg`}
                                        onError={(e) =>
                                        (e.target.src =
                                            "https://www.ultra-erp.pro/products/no_image.jpg")
                                        }
                                        className=" w-36 h-36 object-contain rounded-lg border shadow-sm md:w-40 md:h-40 "
                                    />


                                    {/* INFO */}
                                    <div className="flex-1 pr-6">
                                        <p
                                            className="font-semibold text-gray-900 text-base leading-tight mb-4 px-1 rounded"
                                            style={item.notes && item.notes !== (item.description || item.productName) ? { backgroundColor: '#00D2D2' } : {}}
                                        >
                                            {item.notes || item.description || item.productName}
                                        </p>

                                        <p className="text-sx text-gray-600 mb-1">
                                            Código: <b>{item.code || item.productId}</b>
                                        </p>

                                        <p className="text-sx text-gray-600 mb-2">
                                            Cantidad: <b>{item.qty}</b>
                                        </p>

                                        <p className="text-lg font-extrabold text-brand-primary">
                                            USD {(Math.round(Math.round((item.price ?? item.unitPrice) * 10000) * item.qty / 100) / 100).toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>

                    {/* FOOTER */}
                    <div className="px-3 py-5 border-t bg-white">

                        {/* TOGGLE PROFORMA */}


                        <div className="flex justify-between mb-2 text-sm">
                            <span className="font-medium">SubTotal</span>
                            <span className="font-bold">USD {subtotal.toFixed(2)}</span>
                        </div>

                        <div className="flex justify-between mb-2 text-sm">
                            <span className="font-medium">IVA</span>
                            <span className="font-bold">USD {ivaTotal.toFixed(2)}</span>
                        </div>

                        <div className="flex justify-between mb-4 text-2xl font-bold">
                            <span>TOTAL</span>
                            <span className="text-brand-primary">
                                USD {totalFinal.toFixed(2)}
                            </span>
                        </div>
                        <div className="flex gap-2 mb-3">
                        <button
                            onClick={closeCart}
                            className={`flex-1 py-2 rounded-lg font-semibold transition flex items-center justify-center gap-2 text-black hover:brightness-90 ${
                                isProformaMode ? "bg-[#FFFFB3]" : "bg-[#80FF80]"
                            }`}
                        >
                            <FaPlus className="text-lg" />
                            <span>Continuar agregando</span>
                        </button>
                        <button
                            disabled={cartItems.length === 0}
                            onClick={() => {
                                if (cartItems.length === 0) return;

                                const user = JSON.parse(localStorage.getItem("user"));
                                if (!user) {
                                    alert("Usuario no encontrado");
                                    return;
                                }

                                // 🔥 NORMALIZAR ITEMS DEL CARRITO
                                // (para que buildOrderPayload reciba lo que espera)
                                const normalizedItems = cartItems.map((it) => {
                                    const qty = Number(it.qty || 1);
                                    const price = Number(it.price || it.unitPrice || 0);
                                    const porcentaje = Number(user.porcentaje || 0) / 100;

                                    const subtotalCents = Math.round(Math.round(price * 10000) * qty / 100);
                                    const subtotalStr = (subtotalCents / 100).toFixed(2);
                                    const tax = it.payTax
                                        ? (Math.round(subtotalCents * porcentaje) / 100).toFixed(2)
                                        : "0.00";

                                    return {
                                        idProduct: it.idProduct,
                                        code: it.code ?? it.productId,
                                        description: it.description ?? it.productName,
                                        notes: it.notes || null,
                                        qty,
                                        price,
                                        subtotal: subtotalStr,
                                        tax,
                                        payTax: !!it.payTax,
                                        service: it.service || 0,
                                        acuerdo: it.acuerdo ?? false,
                                    };
                                });

                                // 🔐 ARMAR PAYLOAD FINAL
                                const payload = buildOrderPayload({
                                    items: normalizedItems,
                                    user,
                                    claseOverride: isProformaMode ? " " : (!user?.changeCustomer && user?.groupId === "     1") ? "+" : "*",
                                });

                                // 💾 GUARDAR Y NAVEGAR
                                localStorage.setItem(
                                    "checkout_payload",
                                    JSON.stringify(payload)
                                );

                                closeCart();
                                history.push(isProformaMode ? "/checkout?mode=proforma" : "/checkout");
                            }}
                            className={`
                                    flex-1 py-2 rounded-lg font-semibold transition
                                    flex items-center justify-center gap-2
                                    ${cartItems.length === 0
                                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                    : isProformaMode
                                        ? "bg-brand-primary text-white hover:brightness-90"
                                        : "bg-brand-primary text-white hover:brightness-90"
                                }
                                `}
                        >
                            <FaShoppingCart className="text-lg" />
                            <span>{isProformaMode ? "Procesar Solicitud de Proforma" : t.btnProcedToCheckout}</span>
                        </button>
                        </div>

                        <button
                            onClick={closeCart}
                            className="hidden w-full border border-gray-400 py-3 rounded-lg font-semibold hover:bg-gray-50 transition"
                        >
                            View Cart
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
